if (!customElements.get('bn-build-time-tabs')) {
  customElements.define(
    'bn-build-time-tabs',
    class BnBuildTimeTabs extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.items = Array.from(this.querySelectorAll('[data-tab]'));
        this.panel = this.querySelector('[role="tabpanel"]');
        this.footers = Array.from(this.querySelectorAll('[data-bn-build-time-footer]'));
        if (!this.tabs.length || !this.panel) return;

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activate(tab.dataset.tabValue));
          tab.addEventListener('keydown', (event) => this.onKeydown(event));
        });

        this.addEventListener('shopify:block:select', (event) => {
          const item = event.target.closest('[data-tab]');
          if (item) this.activate(item.dataset.tab);
        });

        const selectedTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
        this.activate(selectedTab.dataset.tabValue);
        this.dataset.initialized = 'true';
      }

      activate(value, moveFocus = false) {
        const activeTab = this.tabs.find((tab) => tab.dataset.tabValue === value);
        if (!activeTab) return;

        this.tabs.forEach((tab) => {
          const isActive = tab === activeTab;
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });

        this.items.forEach((item) => {
          item.hidden = item.dataset.tab !== value;
        });

        this.footers.forEach((footer) => {
          footer.hidden = footer.dataset.bnBuildTimeFooter !== value;
        });

        this.panel.setAttribute('aria-labelledby', activeTab.id);
        this.querySelector('.bn-v3-build-time__viewport')?.scrollTo({ left: 0, behavior: 'auto' });
        if (moveFocus) activeTab.focus();
      }

      onKeydown(event) {
        const currentIndex = this.tabs.indexOf(event.currentTarget);
        let nextIndex;

        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === undefined) return;

        event.preventDefault();
        this.activate(this.tabs[nextIndex].dataset.tabValue, true);
      }
    }
  );
}
